import "./Header.css";

const Header = () => {
  return (
    <>
      <div className="header-container">Notes</div>
      <hr />
    </>
  );
};

export default Header;
